// I disabled eslint because it'll complain about the double quotes
// I'll use double quotes because in the future we may use json files
// instead of a object

/* eslint-disable quotes, quote-props */
const ptBr = {
	// Global
	"active-f": "Ativa",
	"active-true": "Já existe uma enquete ativa",
	add: "Adicionar",
	and: "E",
	all: "Todos",
	also: "Também",
	any: "Qualquer",
	answer: "Responder",
	answers: "Respostas",
	answerSingle: "Resposta",
	missing: "Campo obrigatório",
	readers: "Leitores",
	cancel: "Cancelar",
	clone: "Duplicar",
	citizen: "Cidadão",
	contact: "Contato",
	create: "Criar",
	"created at": "Criado em",
	datas: "Dados",
	data: "Dados",
	date: "Data",
	"date-of-interaction": "Data de interação",
	"date-modification": "Data de modificação",
	delete: "Excluir",
	description: "Descrição",
	disable: "Desativar",
	edition: "Edição",
	"edit-your-infos": "Edite suas informações",
	example: "Exemplo:",
	"has-alredy-active": "Essa enquete já foi ativada anteriormente",
	"have-a-error-in-this-field":
		"Tem um erro neste campo, por favor verifique a informação",
	"invalid-field": "Campo inválido",
	group: "Grupo",
	list: "Grupos",
	location: "Localização",
	message: "Mensagem",
	"must-have-at-east-one-contact-mean":
		"Pelo menos um campo deve ser preenchido",
	"name-exists": "Este nome já existe",
	new: "Nova",
	"no-editions": "Nenhuma alteração foi efetuada",
	no: "Não",
	"not-active": "Não ativa",
	"option-one": "Opção 1",
	"option-two": "Opção 2",
	or: "Ou",
	"page-exists": "Esta página já está cadastrada",
	poll: "Consultas",
	intent: "Temas",
	phone: "Telefone",
	question: "Pergunta",
	sent: "Enviado",
	sentPlural: "Enviados",
	questions: "Dúvidas",
	"activate": "Ativar",
	"to-activate-question": "Ativar pergunta",
	tutorial: "Tutorial",
	upTo: "Em até",
	yes: "Sim",
	you: "Você",
	queries: "Consultas",
	"remove-attachment": "Remover anexo",
	"remove-file": "Remover arquivo",
	"attachment": "Anexo",
	"attachment-will-be-removed-on-save": "A mídia anexada será removida ao salvar",
	"attachments": "Anexos",
	"midia": "Mídia",

	// Alerts - Alertas
	"Access denied": "Faça login novamente",
	"alert-facebook": "Seu assistente digital não tem acesso ao seu Facebook",
	alert: "Alerta",
	"alert-poll":
		"Ao clicar em publicar, esta enquete ficará ativa em seu assistente digital.",
	atention: "Atenção",
	"added-to-group": "Adicionado com sucesso",
	"choice-a-page-to-setup-chatbot": "Ativar assistente virtual.",
	"configure-facebook": "Configurar Facebook",
	"confirm-active-poll":
		"Caso confirme, a enquete ativa será substituida por esta.",
	"confirm-change-password":
		"Um e-mail foi enviado ao seu e-mail cadastrado para confirmação da mudança de senha!",
	"dialog-alert":
		"Você ainda não configurou os diálogos do Assistente Digital",
	"email does not exists": "Esse e-mail não existe",
	"email send": "Solicitação enviada, por favor confira sua caixa de e-mail",
	"email-invalid": "E-mail inválido",
	invalid: "E-mail inválido.",
	"message-after-register":
		"Cadastrado com sucesso, você receberá um e-mail assim que for aprovado.",
	"message-sent": "Mensagem enviada!",
	"no-poll-data": "Você ainda não criou nenhuma enquete",
	"no-premium-text":
		"Envie mensagens para seus seguidores, entre em contato contato@appcivico.com.br",
	"no-premium-title": "Seja premium!",
	"password-need-more-then-six-characters":
		"A senha precisa de pelo menos 6 caracteres",
	"required-field": "Campo exigido.",
	"repeat-password": "Confirmar senha",
	"save-with-success": "Alterações salvas",
	"Bad email or password.": "Seu e-mail ou senha estão incorretos.",
	"zero-poll": "Você não tem nenhuma pergunta",
	"no-publish-poll": "Nenhuma pergunta publicada",

	// Buttons
	active: "Ativo ::: Ativos",
	"be-premium": "Tornar premium",
	configure: "Configurar",
	"create-button": "Criar",
	"edit-page-face-book": "Mudar de página. ",
	edit: "Editar",
	enter: "Entrar",
	login: "Entrar",
	publish: "Publicar",
	"register-desactivate": "Cadastrar desativada",
	save: "Salvar",
	next: "Próximo",
	saving: "Salvando...",
	send: "Enviar",
	ignore: "Ignorar",
	"user not approved": "Seu usuário ainda não foi aprovado.",
	wait: "Aguarde...",

	// Forms - Formulários
	city: "Cidade",
	email: "E-mail",
	female: "Feminino",
	gender: "Gênero",
	male: "Masculino",
	name: "Nome",
	office: "Cargo",
	organizationPicture: "Logo da organização",
	party: "Partido",
	password: "Senha",
	state: "Estado",
	title: "Título",
	movement: "Movimento",
	movements: "Movimentos",
	register: "Cadastrar",

	// Menu
	menuGeneral: "Geral",
	menuEngagement: "Dialogflow",
	menuMessages: "Mensagens",
	menuSegmentation: "Segmentação",
	menuLog: "Logs",
	menuConfig: "Configurações",
	campaigns: "Campanhas",
	dialogs: "Diálogos",
	groups: "Grupos",
	home: "Home",
	menu: "Menu",
	messages: "Mensagens",
	polls: "Enquetes",
	profile: "Perfil",
	push: "Notificações",
	supporters: "Seguidores",
	followers: "Seguidores",
	followersOfGroup: "Seguidores do grupo",
	integrations: "Integrações",
	"alredy in use": "E-mail já em uso",
	inbox: "Caixa de entrada",
	"inbox-count": "Total na caixa de entrada",
	"inbox-count-last-24h": "Mensagens em aberto das últimas 24h",
	"inbox-count-ignored": "Mensagens ignoradas",
	"group-count": "Total de grupos",
	"group-recipient-count": "Total de contatos em grupos",
	"group-recipient-count-not": "Total de contatos sem grupos",
	"campaign-count": "Campanhas criadas",
	"campaign-count-dm": "Campanhas de mensagem criadas",
	"campaign-count-poll": "Campanhas de pergunta criadas",
	"campaign-reach": "Alcance total",
	"campaign-reach-dm": "Alcance por mensagem",
	"campaign-reach-poll": "Alcance por pergunta",
	count_direct_message: "campanhas de mensagem",
	count_poll_propagate: "campanhas de perguntas ao seguidores",
	"response-time": "seu tempo médio de resposta",
	"followers-description": "Novos seguidores",
	minutes: "Minutos",
	count_with_email: "seguidores com email",
	count_with_cellphone: "seguidores com telefone",
	count_facebook: "facebook",
	"of-followers": "dos seguidores",
	"followers-groups": "Seguidores nos grupos",
	"followers-groups-alert":
		"Você tem muitos seguidores sem grupo, filtre seus grupos para melhores resultados.",
	facebook: "Facebook",
	general: "Geral",
	"top-groups": "Grupos principais",
	"top-intentions": "Principais Intenções",
	"top-group": "Grupos principais",
	subject: "Assunto",
	"subtitle-inbox":
		"Caixas de entrada de mensagens diretas enviadas por seguidores.",
	"subtitle-groups":
		"Seus seguidores podem ser segmentos por grupos de acordo com seus interesses ou dúvidas.",
	"campaigns-subtitle": "Verifique suas mensagens",
	"questions-title": "Conhecimento",
	"questions-subtitle": "Perguntas",
	"transmission-list": "Lista de transmissão",
	"trash": "Lixeira",
	"delete-permanently": "Excluir definitivamente",
	"subtitle-questions":
		"Utilize o recurso de perguntas para conhecer melhor seus seguidores. Crie rotinas e sempre consulte sua base para formar novos grupos de acordo com as respostas obtidas.",
	engagement: "Engajamento",
	segmentation: "Segmentação",
	"last-week": "Última semana",
	count_open: "Mensagens não respondidas",
	count_replied: "Mensagens respondidas",
	count_ignored: "Mensagens Ignoradas",
	count_empty: "grupos sem seguidores",
	count_populated: "grupos com seguidores",
	count_segmented_recipients: "em grupos",
	count_non_segmented_recipients: "sem grupo",

	// Login
	"forgot-password": "Esqueceu a senha?",
	"make-your-register": "Crie um novo usuário",

	// Reset Password - Resetar Senha
	"pasword-dont-confirm": "Tente novamente suas senhas não conferem.",
	"reset-password-text":
		"Digite seu e-mail cadastrado para recuperar sua senha",
	"reset-password": "Redefinição de senha",

	// Register - registrar
	"public-representative-registration": "Cadastro de representante público",

	// Overview - Visão Geral
	"home-caption":
		"* A atividade de informações desta página é extraída do facebook insights.",
	"home-subtitle": "Conheça o perfil de seus seguidores nas mídias sociais.",
	"info-box-title-recipient-count": "Contatos únicos",
	"info-box-title-recipient-count-with-email":
		"Contatos com e-mail cadastrado",
	"info-box-title-recipient-count-with-cellphone":
		"Contatos com telefone cadastrado",
	"info-box-title-recipient-count-facebook": "Contatos no Facebook",
	"info-box-title-recipient-count-twitter": "Contatos no Twitter",
	overview: "Visão geral",
	indicators: "Indicadores",
	"set-a-poll-to-see-all-informations":
		"Registre uma enquete para começar a ver as informações!",
	"no-gender": "Sem informações suficientes",
	"no-user": "Ninguém interagiu com seu assistente",
	"users-per-day": "Acessos por dia*",
	"new-followers": "Novos seguidores",
	"followers-subtitle":
		"Usuários que interagiram com seu assistente digital estão cadastrados em sua lista de seguidores.",
	"last-week-subtitle": "Indicadores em destaque dos últimos 7 dias",
	"c-panel-response-error": "Tempo de resposta muito longo",
	"c-panel-campaigns-error":
		"Crie uma campanha para melhorar seu engajamento",
	"c-panel-followers-error": "Você não tem novos seguidores",
	"no-data": "Não temos dados suficientes",
	"no-data-groups": "Crie grupos para segmentar seus seguidores",
	"no-data-reply": "Você ainda não recebeu mensagens",
	"no-campaigns": "Você não enviou nenhuma campanha",
	"processing": "Processando",
	delivers: "envios",

	// Profile - Perfil
	"active-page": "Página Ativa",
	"changeChatBot": "Alterar página",
	"desactive-page": "Página desconfigurada",
	"facebook-config": "Configurar Facebook",
	"no-acess": "Seu assistente não tem acesso ao Facebook",
	"disconnectChatBot": "Desconectar assistente",
	"personal-data": "Dados pessoais",
	"ticket-response-time": "Prazo máximo de resposta",
	"undefined": "Não definido",
	"hours": "Horas",
	"inDays": "em dias",
	"responsibleDescription": "E-mail do responsável que deve ser alertado de um novo chamado",

	// Poll - Enquetes
	"sendPoll": "Enviar enquete",
	"active-poll-subtitle":
		"Essa enquete funcionará no seu assistente digital. Você só pode ter uma enquete ativa",
	"active-poll": "Deseja publicar esta enquete agora?",
	"finished-text":
		"Estas perguntas foram finalizadas e não podem ser publicadas novamente.",
	"finished-title": "Finalizada",
	"my-polls": "Minhas perguntas",
	"no-poll-information": "Sem informações suficientes",
	"no-available-poll": "Nenhuma enquete disponível",
	"no-finished-poll": "Nenhuma enquete realizada",
	"poll-name-text": "Informação disponível apenas no painel",
	"poll-subtitle":
		"Crie uma pergunta e conheça a opinião de seus seguidores em diversos temas",
	"poll-title": "Perguntas",
	"published-text":
		"Esta pergunta foi publicada e está ativa em seu assistente.",

	"question-example":
		"O governo está promovendo um debate sobre crimes digitais e quer conhecer sua opinião. Você já foi vítima de algum tipo de crime digital?",
	"registered-text":
		"Estas perguntas foram cadastradas e não estão publicadas.",
	"registered-title": "Cadastrada",
	"alredy exists": "Este dado já foi cadastrado",
	"page already in use": "Já existe um assistente digital vinculado nessa página",
	"confirm-publish-title": "Você deseja publicar esta enquete?",
	"confirm-publish-text":
		"Ao ativar está enquete, a enquete atual será desativada automaticamente!",
	sendNowTo: "Enviar imediatamente para",
	"create-research": "Criar nova consulta",
	"my-researches": "Consultas",
	"active-research": "Consulta ativa",
	"done-researches": "Realizada",
	"availables-researches": "Disponível",
	"no-active-poll": "Nenhuma enquete ativa",
	"no-one": "Ninguém",
	"activatedQuestion": "Ativa",
	"availableQuestions": "Disponíveis",
	"finalizedQuestions": "Realizadas",
	"active-time-poll": "Ativa há",
	"day": "Dia",
	"days": "Dias",
	"my-researches-subtitle":
		'Veja todas as mensagens e enquetes enviadas para seus seguidores. Clique em "Mensagens" para ver as mensagens em texto enviadas e clique em "Enquetes" para ver as enquetes enviadas.',
	segment: "Segmentar",

	// Dialogs - Dialogos
	"contact-title":
		"Essas informações ficarão visíveis ao seguidores em seu perfil do AppCívico. Divulgue os canais para seu seguidor entrar em contato com sua equipe.",
	"dialog-subtitle":
		"Configure o diálogo de seu assistente digital. Crie a conversa que será usada com seus seguidores.",
	"dialogs-title": "Diálogos fixos",
	"picframe-title": "Quer compartilhar suas campanhas no Facebook?",
	"picframe-explication":
		"Coloque o url do Facebook do seu tema ou post",
	"picframe-subtitle":
		"Crie um tema no Facebook  e mobilize seus seguidores a divulgar sua causa, modificando a foto de perfil com o tema de sua campanha. Ou insira o link de um post que gostaria de compartilhar com seus seguidores.  Monte sua imagem no picframe do facebook ou copie o link de sua postagem.",
	"greeting-title":
		"Crie uma saudação para seu assistente iniciar a conversa com seu seguidor. Ele deve pedir ao seguidor para escrever uma pergunta e descobrir um posicionamento sobre intenções diversas.",
	greeting: "Saudação",
	"facebook-greeting":
		"Mensagem de boas vindas para quando iniciar uma conversa pelo Facebook",
	"website-greeting":
		"Mensagem de boas vindas para quando iniciar uma conversa fora do Facebook",

	// intentions
	condition: "Condição",
	"group-title": "Título do grupo",
	"groups-list": "Lista dos grupos",
	"themes-subtitle":
		"Os temas são criados automaticamente pelo AppCívico, com base no processamento de linguagem natural.",
	filter: "Filtrar",
	"filter-by": "Filtrar por",
	"segment-by": "Segmentar por",
	QUESTION_ANSWER_EQUALS: "Resposta é",
	QUESTION_ANSWER_NOT_EQUALS: "Resposta não é",
	QUESTION_IS_NOT_ANSWERED: "A pergunta não foi respondida",
	QUESTION_IS_ANSWERED: "A pergunta foi respondida",
	GENDER_IS: "Gênero é",
	GENDER_IS_NOT: "Gênero não é",
	INTENT_IS: "Tema é",
	INTENT_IS_NOT: "Tema não é",
	"edit-groups": "Editar grupos",
	"create-group": "Criar grupo",
	"creating-group": "Seu grupo está sendo criado",
	"no-groups": "Você ainda não criou grupos",
	"no-intent": "Você não tem intenções registradas",
	"no-supporters-groups":
		"Por enquanto nenhum seguidor atende as condições desse grupo.",
	"select-groups": "Adicionar em grupo",
	"select-groups-error": "Esse grupo já foi inserido",
	"add-recipient-to-group-error": "Esse usuário já está nesse grupo",
	intentions: "Intenções",
	intention: "Intenção",
	"intention-name": "Intenção",
	"no-supporters-intents": "Nenhum seguidor tem interesse nesse tema",
	"no-supporters-group": "Você não tem seguidores nesse grupo",
	"themes": "Temas",
	"theme": "Tema",
	"positioning": "Posicionamento",
	"no-positioning": "Você não tem nenhum posicionamento",
	"no-disabled-positioning": "Você não tem nenhum posicionamento desabilitado",
	"no-pending-themes": "Você não tem nenhum posicionamento pendente",
	"positionings": "Posicionamentos",
	"positionings-subtitle": "Apresente as respostas para cada ponto de vista cadastrados no DialogFlow. Sincronize para atualizar a plataforma. Em pendentes estão as intenções não ativas e/ou sem resposta",


	// Tickets
	"anonymous": "Anônimo",
	"ticket": "Chamado",
	"tickets": "Chamados",
	"ticketsConfigDescription": "Configurações dos chamados",
	"tickets-subtitle":
		"Todas as solicitações de seus clientes estão nesta área. Você pode responder direto ao clientes, atribuir tarefas para participantes do seu time e acompanhar o status de cada solicitação.",
	"ticketDetails-subtitle":
		"Atribua um responsável para a solicitação, adicione o status do ticket, anexe um arquivo caso necessário e responda rapidamente o seguidor.",
	"solicitation": "Solicitação",
	"responsible": "Responsável",
	"request": "Solicitação:",
	"id": "Id",
	"productName": "Nome do produto",
	"quantity": "Quantidade",
	"totalPoints": "Pontos",
	"noResponsible": "Sem responsável",
	'dataSent': "Envio de dados",
	'dataRevogation': "Revogação dos dados",
	'pending': "Pendente",
	'progress': "Em andamento",
	'inProgress': "Em andamento",
	'closed': "Fechado",
	'canceled': "Cancelado",
	'logs': "Logs",
	'logs-subtitle': "Procedimentos realizados sobre a solicitação",
	'taskAttr': "Atribuição de tarefa",
	'ticketStatus': "Status do chamado",
	'ticketStatusPlaceholder': "Selecione o status do chamado",
	'ticketResponsibePlaceholder': "Responsável pelo ticket",
	'update': "Atualizar",
	'requestDate': "Data de solicitação",
	'CPF': "CPF",
	'noData': "Sem dados no momento",


	// Messagens - Mensagens
	"add-to-group": "Adicionar a um grupo",
	"mark-as-not-read": "Marcar como não lida",
	"no-message": "Sua caixa de entrada está vazia",
	"add-recipient-to-groups": "Adicionar em grupos",
	"send-messages": "Enviar mensagens",
	"open-messages": "Mensagens em aberto",
	"open-messages-subtitle":
		"Quando seu assistente não entende uma mensagem de um seguidor, esta mensagem aparece aqui na sua caixa de entrada. Responda o mais rápido possível clicando abaixo",
	opened: "Em aberto",
	"replied-messages": "Mensagens Respondidas",
	"replied-messages-subtitle":
		"Essas mensagens são as que foram respondidas, e não há mais possibilidade de interação com eles",
	"replied-message": "Mensagem Respondida",
	"ignored-messages": "Mensagens Ignoradas",
	"ignored-messages-subtitle": "São mensagens que foram ignoradas",
	"ignored-message": "Mensagem Ignorada",
	ignored: "Ignoradas",
	replied: "Respondidas",
	"inbox-count-open": "Mensagens em aberto",
	reply: "Resposta",
	"text-reply": "Resposta em texto",
	"file-reply": "Resposta em mídia",
	back: "Voltar",
	"showUnreadOnly": "Exibir apenas não lidas",
	"showAll": "Exibir todas",
	"select-all": "Selecionar tudo",
	"selected-messages": "Mensagens selecionadas",
	"send-new-message": "Enviar nova mensagem",
	"send-file": "Enviar arquivo",
	"send-file-subtitle": "Deixe sua campanha mais interessante enviando imagem, audio ou vídeo.",
	"no-theme-on-message": "O tema da mensagem será definido em até 72h.",
	"no-active-knowledge": "Você não tem posicionamento cadastrado sobre o tema",
	"no-active-knowledges": "Você não tem posicionamento cadastrado sobre os seguintes temas:",
	"create-knowledge": "crie um posicionamento",
	"points-of-view": "Pontos de vista",

	// Campaigns - Campanhas
	"mark-as-read": "Marcar todas como lidas",
	"name-notifications-subtitle":
		"Defina o tema de sua enquete. Esta informação ficará disponível apenas para sua equipe.",
	"no-notifications": "Nenhuma notificação no momento",
	"not-read": "Não lidos",
	"notifications-subtitle":
		"Envie uma mensagem direta (broadcast) para sua lista de seguidores ativos. Seus seguidores receberão a mensagem através do assistente cívico",
	"notifications-title": "Mensagens Diretas",
	"view-all": "Visualizar todas",
	"send-poll": "Enviar pergunta",
	"send-question": "Enviar pergunta para sua base",
	select: "Selecionar",
	upload: "Enviar arquivo",
	"image-or-content": "Por favor, envie a imagem ou o conteúdo",
	"send-poll-subtitle":
		"Faça uma pesquisa entre seus seguidores e monte novos grupos",
	"send-campaigns": "Enviar campanhas",
	"campaign-title": "Titulo da campanha",
	"campaign-message": "Escreva uma mensagem ou envie uma imagem para seus seguidores",
	"send-image": "Enviar imagem",
	"send-image-or-audio": "Enviar imagem ou audio",
	"campaign-segment": "Envie sua campanha para toda sua base ou segmente por grupos (você pode selecionar mais de um grupo)",
	"subtitle-campaigns": "Campanhas são importantes para o envolvimento com seguidores. Envie mensagens para toda sua base ou grupos.",
	"poll-propagate-title": "Alcance da enquete ativa",

	// Followers - Seguidores
	"no-supporters": "Você ainda não tem seguidores",
	supporter: "Seguidor",
	"supporters-subtitle": "Essa é a relação de todos os seus seguidores nas redes que utiliza a plataforma do AppCívico",
	"supporter-groups": "Grupos do seguidor",
	"first-interaction": "Primeira interação",
	"question-first-interaction":
		"Programar envio de consulta depois da primeira interação do usuário",
	network: "Rede",

	// Followers - Seguidores
	"no-logs": "Você ainda não tem atividades registradas",
	"activities-register": "Registro de atividades",

	// intregrations - Integrações
	"votolegal-text": "Você deseja receber financiamento para sua campanha?",
	"votolegal-greeting":
		"Preencher mensagem de boas vindas para quando o AppCívico abrir pelo VotoLegal",
	"twitter-text": "Deseja ativar seu assistente digital no twitter?",
	"twitter-subtitle": "Entre em contato com nossa equipe",
	"to-integrate": "Integrar",
	"no-account": "Não tem conta?",
	"create-account": "Cadastre-se",
	"facebook-documentation": "Documentação do Facebook",
	"remove-integration": "Remover integração",
	"mail-voto-legal":
		"Coloque o e-mail de cadastro utilizado pelo VotoLegal para realizar a integração",
	"picframe-error":
		"Formato inválido. Certifique-se de enviar uma url do facebook",
	"picframe-text":
		"Coloque o texto para que seu assistente digital convide seus seguidores a compartilhar",

	// knowledge
	training: "Treinamento",
	"no-historic": "Você não possui perguntas novas",
	"new-knowledge": "Criar conhecimento",
	knowledge: "Conhecimento",
	repository: "Repositório",
	"to-synchronize": "Sincronizar",
	"synchronizing": "Sincronizando...",
	"succesfull-sync": "Sincronia concluída",
	"unsuccesfull-sync": "Falha na sincronização",
	"public-question": "Pergunta pública",
	"public-reply": "Resposta pública",
	"knowledge-with-attachment": "Este posicionamento possui uma mídia anexada",
	"activated": "Ativado ::: Ativados",
	"disabled": "Desativado ::: Desativados",
	"send-file-instructions": "Envie imagens, áudios ou vídeos. Tamanho máximo de 25MB",
	"no-repository":
		"Você ainda não tem conhecimento cadastrado no seu repositório",
	learning: "Aprendizagem",
	"training-subtitle":
		"As mensagens respondidas ficam registradas. Treine seu assistente digital, criando conhecimentos de acordo com as intenções dos seus seguidores.",
	"knowledges-subtitle":
		"Conhecimento é todo conteúdo aprendido pelo seu assistente digital. Os conhecimentos podem ser ativos de acordo com seus objetivos.",

	// Footer - Rodapé
	"all-rights-reserved": "Todos os direitos reservados - Copyright ©",
	"any-questions": "Dúvidas?",
	"contact-us": "Entre em contato",
	"developed-by": "Desenvolvido por",

	// Tour Guide
	"tour-guide__nextLabel": "próximo",
	"tour-guide__prevLabel": "anterior",
	"tour-guide__doneLabel": "pronto",
	"tour-guide__skipLabel": "pular",
	"tour-guide__interactions-count":
		"Todas as interações com seu Assistente Digital aparecerão aqui.",
	"tour-guide__interactions-chart":
		"Acompanhe o gráfico das interações por período.",
	"tour-guide__to-facebook-bind": "Primeiro, víncule sua página do Facebook",
	"tour-guide__facebook-setup":
		"Vincule sua página do Facebook aqui para ativar o chatbot.",
	"tour-guide__to-setup-dialogs":
		"Em seguida, configure os diálogos que seus seguidores receberão.",
	"tour-guide__choose-greeting": "Escolha sua mensagem de saudação.",
	"tour-guide__contact":
		"Cadastre os meios que seus seguidores poderão entrar em contato.",
	"tour-guide__bio": "Conte sobre você. Ao lado, veja uma prévia do diálogo.",
	"tour-guide__to-polls": "Para saber mais sobre seguidores, crie enquetes.",
	"tour-guide__poll-name":
		"Para sua identificação, dê um nome para a enquete.",
	"tour-guide__poll-question":
		"O que quer saber? Cadastre a pergunta que deseja.",
	"tour-guide__poll-options":
		"Insira duas respostas possíveis para essa enquete.",
	"tour-guide__poll-submit":
		'Clique em "Ativar". Se tiver alguma enquete ativa, ela será substituída.',
	"tour-guide__poll-list": "Veja os resultados das enquetes e seu status.",
	"tour-guide__notification-name":
		"Para sua identificação, dê nome para a notificação.",
	"tour-guide__notification-message":
		"Os seguidores que interagiram com o seu chatbot receberão qual mensagem?",
	"tour-guide__notifications-previous":
		"Veja seus histórico de notificações.",
	"tour-guide__supporters": "Lista de seguidores",
	"tour-guide__interactions-grupos":
		"Total de grupos de segmentação que você possui.",
	"tour-guide__interactions-notifications":
		"Veja seu histórico de notificações",
	"tour-guide__interactions-response-notification":
		"Digite sua resposta aqui e envie",
	"tour-guide__interactions-groups-create": "Crie grupos de segmentação",
	"tour-guide__interactions-groups-list": "Veja a listagem dos seus grupos",
	"tour-guide__interactions-groups-edit":
		"Edite, remova ou faça uma cópia do grupo selecionado.",
	"tour-guide__interactions-groups-filter":
		"Selecione a enquete que você quer segmentar.",
	"tour-guide__interactions-groups-condition":
		"Escolha um padrão para busca de respostas.",
	"tour-guide__interactions-groups-answer":
		"Escolha qual a resposta base para criação do grupo.",
	"tour-guide__interactions-groups-more-rules":
		"Selecione “+” para adicionar um novo filtro ao grupo.",
	"tour-guide__interactions-groups-rules":
		"Monte grupos com todos os filtros configurados.",
	"tour-guide__interactions-groups-rules-other":
		"Monte grupos com apenas um dos filtros configurados.",
};

export { ptBr as default };



// WEBPACK FOOTER //
// ./_source/javascripts/translations/ptBR.js